import type { FC } from 'react';
import useSettings from 'src/hooks/useSettings';
import { Box, Container } from '@mui/material';
import ActivityGrid from 'src/components/dashboard/overview/ActivityGrid/ActivityGrid';
import { getSettingsWidth } from 'src/utils/settingsHelper';

interface ActivityGridProps {
  showCostomerColumn?: boolean;
  defaultFilterByTask?: boolean;
  className?: string;
}

const Activity: FC<ActivityGridProps> = (props) => {
  const contentWidth = useSettings((state) => state.settings.contentWidth);

  return (
    <Box sx={{ py: 5 }}>
      <Container maxWidth={getSettingsWidth(contentWidth)} className={`container-width__${contentWidth}`}>
        <ActivityGrid {...props} />
      </Container>
    </Box>
  );
};

export default Activity;
